// Shared template-composer UI types matching Meta WhatsApp Cloud API v20+
// and the backend contract in docs/agents/WP-01-backend/report.md.

export type TplCategory = 'MARKETING' | 'UTILITY' | 'AUTHENTICATION';

export type TplTemplateType =
  | 'general'
  | 'mixed'
  | 'carousel_media'
  | 'carousel_product'
  | 'otp';

export type TplHeaderType = 'NONE' | 'TEXT' | 'IMAGE' | 'VIDEO' | 'DOCUMENT' | 'LOCATION';

export type TplButtonType = 'QUICK_REPLY' | 'URL' | 'PHONE_NUMBER' | 'COPY_CODE' | 'OTP';

export type TplLang = string;

export interface TplButton {
  type: TplButtonType;
  text: string;
  url?: string;
  phone_number?: string;
  example?: string | string[];
}

export type WaTemplateVariableSource =
  | 'name'
  | 'phone'
  | 'static'
  | `custom:${string}`
  | `system:${string}`;

export interface WaTemplateVariable {
  index: number;
  source: WaTemplateVariableSource;
  example: string;
}

export interface WaTemplateHeaderMedia {
  handle: string;
  mime: string;
  size: number;
  storagePath: string;
  createdAt: number;
}

export interface TplCarouselCard {
  id: string;
  mediaType: 'IMAGE' | 'VIDEO';
  mediaHandle?: string;
  mediaStoragePath?: string;
  bodyText: string;
  buttons: TplButton[];
}

export interface TplComponent {
  type: 'HEADER' | 'BODY' | 'FOOTER' | 'BUTTONS' | 'CAROUSEL' | 'LIMITED_TIME_OFFER';
  format?: 'TEXT' | 'IMAGE' | 'VIDEO' | 'DOCUMENT' | 'LOCATION';
  text?: string;
  example?: {
    header_text?: string[];
    header_handle?: string[];
    body_text?: string[][] | string[];
  };
  buttons?: Array<{
    type: 'QUICK_REPLY' | 'URL' | 'PHONE_NUMBER' | 'COPY_CODE' | 'OTP';
    text?: string;
    url?: string;
    phone_number?: string;
    example?: string | string[];
  }>;
  cards?: Array<{
    components: any[];
  }>;
}

/** Pre-set system variables from WhatChimp spec (WP / system variables). */
export const SYSTEM_VARIABLES: Array<{ key: string; label: string }> = [
  { key: 'system:appointment:booking-id', label: 'Appointment Booking ID' },
  { key: 'system:appointment:date', label: 'Appointment Date' },
  { key: 'system:appointment:time-start', label: 'Appointment Time' },
  { key: 'system:appointment:google-meet-link', label: 'Google Meet Link' },
  { key: 'system:cart:checkout-link', label: 'Abandoned Cart Checkout Link' },
  { key: 'system:cart:total-price', label: 'Cart Total Price' },
  { key: 'system:coupon:code', label: 'Coupon Code' },
  { key: 'system:coupon:percentage', label: 'Coupon Discount %' },
  { key: 'system:delivery-date', label: 'Estimated Delivery Date' },
  { key: 'system:shipping-address', label: 'Shipping Address' },
];

/** Common subscriber custom fields available before customFieldList loads. */
export const COMMON_CUSTOM_FIELDS: Array<{ key: string; label: string }> = [
  { key: 'custom:order_id', label: 'Order ID (order_id)' },
  { key: 'custom:company', label: 'Company Name (company)' },
  { key: 'custom:discount_pct', label: 'Discount % (discount_pct)' },
  { key: 'custom:balance', label: 'Account Balance (balance)' },
  { key: 'custom:points', label: 'Loyalty Points (points)' },
  { key: 'custom:expiry_date', label: 'Membership Expiry (expiry_date)' },
];
